export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-latin-400-normal.woff2?35d2378fea369960176b767aeab707a2";